export default "__VITE_ASSET__BudRrdiM__"